import { IconButton, IconButtonProps } from '@mui/material'
import { FullscreenIcon } from 'icons'
import { Icon } from 'hello-design-system'
import { MatButtonCustomised } from 'components/mat-theme/button'

type SidebarButtonProps = {
    id?: string
    icon?: string
    onClick?: IconButtonProps['onClick']
}

const CloseButton: React.FC<SidebarButtonProps> = ({ id, onClick }) => (
    <MatButtonCustomised
        id={id}
        onClick={onClick}
        width='40px'
        height='40px'
        borderRadius='48'
    >
        <Icon iconName='CloseRounded' width={24} />
    </MatButtonCustomised>
)
const FullscreenButton: React.FC<SidebarButtonProps> = ({ id, onClick }) => (
    <IconButton
        id={id}
        onClick={onClick}
        sx={theme => ({
            backgroundColor: 'transparent',
            height: theme.spacing(3.125),
            width: theme.spacing(4),
            padding: 0,
            borderRadius: theme.spacing(0.625),
            overflow: 'hidden',
            img: {
                width: theme.spacing(4.75),
                maxWidth: 'none'
            }
        })}
    >
        <img src={FullscreenIcon} />
    </IconButton>
)
const BackButton: React.FC<SidebarButtonProps> = ({ id, onClick }) => (
    <MatButtonCustomised
        id={id}
        onClick={onClick}
        width='40px'
        height='40px'
        borderRadius='48'
    >
        <Icon iconName='ArrowBackRounded' width={24} />
    </MatButtonCustomised>
)

export { CloseButton, FullscreenButton, BackButton }
